import axios from 'axios';
import lstModules from 'common/json/lstModules.json';
import { Form } from 'react-router-dom';

var tokenid = localStorage.getItem("tokenid");
var httpURL = lstModules['main'].url + ":" + lstModules['main'].port;




export function getClassListSvc(callback1) {
    axios({
        url: httpURL + '/sms/cls/list',
        method: "POST",
        headers: { 'tokenid': tokenid },
        withCredentials: true,
    }).then((response) => {
        // console.log('data.SvcStatus=' + response.data.SvcStatus);
        callback1(response.data);
    }).catch((error) => {
        callback1(error);
    });
}
export function getSectionListSvc(callback2, pClassId) {
    axios({
        url: httpURL + "/sms/cls/sec/list",
        method: "POST",
        params: { classId: pClassId },
        headers: { 'tokenid': tokenid },
        withCredentials: true,
    }).then((response) => {
        // console.log('data.SvcStatus=' + response.data.SvcStatus);
        callback2(response.data);
    }).catch((error) => {
        callback2(error);
    });
}


export const subjectTeacherListSvc = (sectionId, callback) => {
    // console.log("subjectTeacherListSvc called, sectionId", sectionId);
    const formData = new FormData();
    formData.append("sectionId", sectionId);
    var obj = { status: "Success", message: "" }
    axios({
        url: httpURL + '/sms/tt/v2/teacher_allocation/list_subject_teachers',
        method: "POST",
        headers: { 'tokenid': tokenid },
        data: formData,
        withCredentials: true,
    }).then((response) => {
        // console.log('response in subjectTeacherListSvc', response);
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        if (response.data.SvcStatus === "Success") {
            obj.lstSub = response.data.lstSub;
        }
        callback(obj);
    }).catch((error) => {
        obj.status = "Exception";
        obj.message = error;
        callback(obj);
    });
}

export const saveSubjectTeacherSvc = (sectionId, syllabusId, subjectId, tchId, addAllocation,flgAddlTch, flgUpdateTimetable, flgAvoidClash, callback) => {
    // console.log("saveSubjectTeacherSvc called, sectionId", sectionId);
    const formData = new FormData();
    formData.append("sectionId", sectionId);
    formData.append("syllabusId", syllabusId);
    formData.append("subjectId", subjectId);
    formData.append("tchId", tchId);
    formData.append("flgAddlTch", flgAddlTch)
    formData.append("updateTimetable", flgUpdateTimetable)
    formData.append("avoidClash", flgAvoidClash)
    formData.append("addAllocation", addAllocation);
    var obj = { status: "Success", message: "", subjectId, tchId }
    axios({
        url: httpURL + '/sms/tt/v2/teacher_allocation/manual_allocation',
        method: "POST",
        headers: { 'tokenid': tokenid },
        data: formData,
        withCredentials: true,
    }).then((response) => {
        // console.log('response in saveSubjectTeacherSvc', response);
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        callback(obj, flgAddlTch);
    }).catch((error) => {
        obj.status = "Exception";
        obj.message = error;
        callback(obj, flgAddlTch);
    });
}
